module.exports = __webpack_public_path__ + "static/media/3.ba3e452b.JPG";